/**
 * replace :{param key} with param.key value
 * @param route
 * @param params
 * @return {*}
 */
const url = (route, params) => {
  let urlString = route;
  const paramKey = Object.keys(params);
  paramKey.forEach((param) => {
    urlString = urlString.replaceAll(`:${param}`, params[param]);
  });
  return urlString;
};

export default url;
